import React, { FC, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import { ReactComponent as CopyIcon } from "assets/images/svgs/ambassador/File-copy.svg";
import { ReactComponent as Facebook } from "assets/images/svgs/ambassador/Social.svg";
import { ReactComponent as Twitter } from "assets/images/svgs/ambassador/Social1.svg";
import { ReactComponent as WhatsApp } from "assets/images/svgs/ambassador/Social2.svg";
import { ReactComponent as Instagram } from "assets/images/svgs/ambassador/Social3.svg";
import useStore from "hooks/useStore";

interface BusinessRegistrationLinkProps {
  isOpen: boolean;
  onClose: () => void;
  handleConfirm?: () => void;
}

const GoalOfNewBusiness: FC<BusinessRegistrationLinkProps> = ({
  isOpen,
  onClose,
  handleConfirm,
}) => {
  const modalRef = useOutsideClick(() => {
    if (isOpen) onClose();
  });

  const {getAmbassadorreferralCode} = useStore()

  const referralCode = getAmbassadorreferralCode()

  const link = "https://learnlocal.app/ambassador/" + referralCode + "/businessRegistration";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShareClick = () => {
    handleCopy();
    if (handleConfirm) handleConfirm();
  };

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[500px] md:w-[550px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl sm:text-2xl font-bold text-center mb-2 text-rsvpBlackie">
          Business Registration Link
        </h2>
        <p className="text-left text-sm sm:text-base text-rsvpBlackie mb-6">
          Click the link below to copy the link for Registering the business
          for Learn Local App.
        </p>

        <div className="bg-[#F8F8F8] px-4 py-3 rounded-xl flex items-center justify-between mb-2">
          <span className="text-sm text-gray-500 truncate">{link}</span>
          <button onClick={handleCopy}>
            <CopyIcon className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {copied && (
          <p className="text-xs text-green-500 text-center mb-2">
            Link copied to clipboard!
          </p>
        )}

        <p className="text-left text-sm text-gray-400 mb-4">
          Anyone with the link can view these results
        </p>

        {/* <div className="text-left mb-6">
          <div className="flex justify-left gap-4">
          <p className="text-sm text-rsvpBlackie mb-2">Share via</p>
            <Facebook className="w-5 h-5 cursor-pointer" />
            <Twitter className="w-5 h-5 cursor-pointer" />
            <WhatsApp className="w-5 h-5 cursor-pointer" />
            <Instagram className="w-5 h-5 cursor-pointer" />
          </div>
        </div> */}

        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
          <button
            className="flex-1 bg-ambassadorBlue text-white py-3 sm:py-5 rounded-full font-medium text-sm sm:text-base"
            onClick={handleShareClick}
          >
            Copy Link
          </button>
          <button
            className="flex-1 bg-[#F1F1F1] text-rsvpBlackie py-3 sm:py-5 rounded-full font-medium text-sm sm:text-base"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoalOfNewBusiness;
